export var DiscountType;
(function (DiscountType) {
    DiscountType["PRICE_DROP"] = "PriceDrop";
    DiscountType["CARROT_CASH"] = "CarrotCash";
    DiscountType["CHFAR_REDEMPTION"] = "ChfarRedemption";
})(DiscountType || (DiscountType = {}));
export var TagType;
(function (TagType) {
    TagType["Algomerch"] = "algomerch";
})(TagType || (TagType = {}));
export var AlgomerchTag;
(function (AlgomerchTag) {
    AlgomerchTag["BestFlight"] = "BestFlight";
    AlgomerchTag["Cheapest"] = "Cheapest";
    AlgomerchTag["BestQuality"] = "BestQuality";
    AlgomerchTag["Fastest"] = "Fastest";
})(AlgomerchTag || (AlgomerchTag = {}));
//# sourceMappingURL=constants.js.map